<template>
  <div id="landing_page">
    <!-- 手機版頁首 -->
    <header>
      <div class="header-logo">
        <div class="header-w">
          <a @click.prevent="redirectToHome">
            <img id="header-logo-m" :src="$getThemeImagePath('lights_m.png')" alt="">
          </a>
          <a class="btn btn--orange" @click.prevent="redirectToHome('register')">新規登録</a>
        </div>
      </div>
    </header>
    <main>
      <div class="fv mt">
        <h1>
          <img class="sp-none" :src="$getThemeImagePath(`lpfv-pc-${bonusAmount}.png`)" :alt="`勝win入金不要ボーナス${bonusAmount}円・高速出金平均5分・初回キャッシュバッグ50%`">
          <img class="pc-none" :src="$getThemeImagePath(`lpfv-sp-${bonusAmount}.png`)" :alt="`勝win入金不要ボーナス${bonusAmount}円・高速出金平均5分・初回キャッシュバッグ50%`">
        </h1>
      </div>
      <div class="btn-cover">
        <a class="btn3 btn-block3 btn-xl3 btn-primary3" @click.prevent="redirectToHome('register')">
          <span class="btn-content">今すぐ登録</span>
        </a>
      </div>
    </main>

    <section class="serect">
      <h2 class="tittle">
        勝winが選ばれる理由
      </h2>
      <div class="container">
        <div class="top-row">
          <div class="flame">
            <div class="number">
              1
            </div>
            <h4 class="tittle4">
              平均5分の高速出金<br>（KYC完了が条件）
            </h4>
          </div>
          <div class="flame">
            <div class="number">
              2
            </div>
            <h4 class="tittle4">
              甘い入金不要ボーナス<br>{{ bonusAmount }}円（賭け条件8倍）<br>安心のスロットやライブゲーム内に禁止ゲーム無し
            </h4>
          </div>
          <div class="flame">
            <div class="number">
              3
            </div>
            <h4 class="tittle4">
              業界TOPレベルの<br>初回キャッシュバック50％<br>最大77,777円キャッシュバック<br>（最大155,555円入金）
            </h4>
          </div>
        </div>
        <div class="bottom-row">
          <div class="flame">
            <div class="number">
              4
            </div>
            <h4 class="tittle4">
              24時間パチンコと世界の競馬<br>（日本を含む）が遊べる
            </h4>
          </div>
          <div class="flame">
            <div class="number">
              5
            </div>
            <h4 class="tittle4">
              24時間対応の完全日本語<br>カスタマーサポート<br>初心者でも安心の環境でプレイ可能
            </h4>
          </div>
          <div class="flame">
            <div class="number">
              6
            </div>
            <h4 class="tittle4">
              魅力的なVIPプログラム<br>最大377万円の昇格ボーナス<br>最大1.6％のリベートボーナス
            </h4>
          </div>
        </div>
      </div>
    </section>

    <section class="benefits">
      <h2 class="tittle">
        新規登録特典とは？
      </h2>
      <div class="white">
        <img class="img" :src="$getThemeImagePath(`registration-${bonusAmount}.png`)" alt="">
        <img class="side-phl2" :src="$getThemeImagePath('giftbox.png')" alt="">
      </div>
    </section>

    <section class="events">
      <div class="new-events">
        <h2 class="tittle">
          人気イベント
        </h2>
        <div class="new-events-div">
          <VueSlickCarousel
            v-if="brandImage.length !== 0"
            class="list"
            v-bind="slick_setting"
          >
            <div
              v-for="item in brandImage"
              :key="item.id"
              class="new-swiper-slide"
            >
              <a @click.prevent="handleClick(item.link,item.open_type)">
                <img :src="item.image" alt="">
              </a>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </section>

    <!-- /.events -->
    <section class="introduction">
      <img class="pic" :src="$getThemeImagePath('about_bg04.png')" alt="">
      <img class="side-ph" :src="$getThemeImagePath('db_gift_right.png')" alt="">
      <div class="cover">
        <h4 class="h4">
          勝winへようこそ
        </h4>
        <h2 class="tittle5">
          「栄華はあなたの望み通り、勝利はあなたの手の中に」
        </h2>
        <p class="text">
          勝winは2023年に誕生した、すべてのゲーム愛好家へ向けたオンラインカジノです。<br>バカラ、ルーレット、スロットマシンなど、<br>魅力あふれる「プレミアムオンラインカジノ」体験をご提供いたします。
          <br>
          <br>オンラインカジノを試したい方へのお知らせ！<br>勝winはユニークで刺激的な環境を提供しています。<br>ライブを通じてラスベガスのカジノへ足を運び、実際にゲームをプレイできます。<br>ディーラーとの会話や共にプレイする体験を通じて、<br>まさに現実的なオンラインカジノをお楽しみいただけます。
        </p>

        <h2 class="tittle2">
          無料登録して<br>
          新規登録特典をGET！
        </h2>
        <a class="btn btn-block btn-xl btn-primary" @click.prevent="redirectToHome('register')">
          <span class="btn-content">今すぐ登録</span>
        </a>
      </div>
    </section>

    <section class="game">
      <h2 class="tittle">
        7,000種類以上の<br class="bn">豊富なゲーム
      </h2>
      <div class="slick-list">
        <div class="slick-div scroll-start">
          <div
            v-for="(item, key) in gameCategory"
            :key="key"
            class="games-type"
            @click.stop="changeGameCategory(item)"
          >
            <img class="main-games-btn" :src="item.image" :alt="item.name">
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>

      <VueSlickCarousel class="slider" v-bind="slick_setting_2">
        <div
          v-for="(slide, index) in slide1"
          :key="index"
          class="slide"
        >
          <img :src="$getThemeImagePath(`${slide.image}`)" :alt="slide.text">
          <p>{{ slide.text }}</p>
        </div>
      </VueSlickCarousel>

      <VueSlickCarousel class="slider2" v-bind="slick_setting_3">
        <div
          v-for="(slide, index) in slide2"
          :key="index"
          class="slide2"
        >
          <img :src="$getThemeImagePath(`${slide.image}`)" :alt="slide.text">
          <p>{{ slide.text }}</p>
        </div>
      </VueSlickCarousel>
    </section>

    <section class="support">
      <div class="inner">
        <h2 class="tittle">
          遊び方についてはこちら
        </h2>
        <div class="support-select-frame">
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-how-to-register"
          >
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAADMCAMAAADnPtf+AAAAqFBMVEUAAABAQEBAQEA4QEBAQEA6QEBAQEA8QEBAQEA9QEBAQEA9QEBAQEA9QEA+QEBAQEA+QEA+QEA+QEA/QEA+QEA/QEA+QEA/QEA+QEA/QEA/QEA/QECxp4GqoH2jmnmimnmclHWblHWck3WVjXGUjXCNhm2GgGmGgGh/emR3c2BxblxxbV1xbVxwbVxqZ1hqZlhpZlhiYFRcWlBbWVBUU0xNTUhGR0Q/QEBLWOK1AAAAHHRSTlMAECAgMDBAQFBQYGBwcH+AgI+Qn6CvsL/Az9/vJNkbKwAAA0BJREFUeNrt3Y1S00AUxfFNRECRonzb7hahFUSlIprc938zHRzMxxkGwmS7OZnzf4PfUDJpsrfXKaWUUkoppZRSSvVQPjk66aWD91uZS9zuzHrsZCd3CXtrfXeQ0DO1/ptkLk0bFqNp7pK0ZXHadSnKLVITl6KPo+JsWqy2XYL2LFKz3CUo3z/91Ue/rdWJS5Pvp+XtE581Ko33Zw3P1LUi03h/bbXeuGZ0mhoH/3P4NP7Gql65RoSaUDx6g0Oo8VeV5tg1YtSE8rGrGqPG/7D/Za4epebLY5cBSs3nSrPp6lFqltJII4000kgjjTTSSCONNNJIIw2tJnxahLFowrfSzFbzUWjmhd1XzMegWZk9cPg1wazi0GuWVueway6swSHXhLLJ4db4G2tyuDWhaHGoNf6szaHWIIdagxxqDXKoNcih1iCHWoMcag1yqDXIodYgh1qDHGoNcqg1yKHWIIdagxxqDXKoNcih1iCHWoMcag1yqDXIodYgh1qDHGoNcpJostdbT7bAsEsDzro12YeZRQk58TX51OJVhDVrDi1mX9erySxqZXieZuBT0A+dP08z6An1qsVaNdnMohZiarB9i9mtX68mi3qFPourwfLDiJgUdzabELTEsKuyhWG+65wXLQzzPTRgmL8RAIb52xpgmL9JA4b5KQdgmJ9AAYb56SBgmJ/cAob5qTpgmN94AIb5bRRgmN8UAob5LS5gmN+wA4b59ANgmE+mAIb51BBgmE90AYb5tB1gmE9CAob5lCpgmE8QA4b5dDdgmE/eA4Z6KmLVwlBPrIQWhnuaaNnEkE96XTQw7FN4oaxh6Cck/U2F4Z9e9aF4wIxhsvjfb9WW38Mopr7/Fpbno5nIH9uvJUgjjTTSSCONNNJII4000kgjjTTS9LD5YsPVo9SsRrWVpBjTxpjLUW3zKSrNjmtEqLm2qtw14tPUMaeuGZ2mhsEPGplmfjeazX5h8dMs9Z8mnxzd9VFhVd0vz4Pcjv3SxcWD3Y79wu2eg92Ofd+e69DQZ4+7YQY+F/7OdWrQ27GnG65zg92OvZe5rg11O/bsZRv/B7kd+3Ttfxfcjt1Lx4e725lTSimllFJKKaWU6tIfr4+E1TTPQxkAAAAASUVORK5CYII="
              alt=""
              class="sup-items-img"
            >
            <p class="txt">登録方法</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-how-to-login"
          >
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAADMCAMAAADnPtf+AAAAz1BMVEUAAABAQEBAQEA4QEBAQEA6QEBAQEA8QEBAQEA9QEA+QEBAQEA9QEBAQEA9QEA+QEBAQEA+QEA+QEA+QEA/QEBAQEA+QEA/QEA+QEA/QEA+QEA/QEA/QEA/QEA/QEA/QECxp4GqoH2jmnmimnmclHWblHWVjXGUjXCNh2yNhm2NhmyGgGmGgGh/emR+emR/eWR4dGF4c2F4c2B3c2BxblxxbVxwbVxxbFxqZ1hpZ1hqZlhpZlhjYFRiYFRcWlBbWVBVU0xUU0xNTUhGR0Q/QEC+1uZ3AAAAIHRSTlMAECAgMDBAQFBQX2BgcHB/gICPkJ+goK+wv8DP0N/g71nKwYwAAAl3SURBVHja7JxvU9s4EMYlx7GT2nXq2k3iGCGH/uGYgxmmTG865Y4cjr7/Z7rC3AxL6sDqkXHFTH6vScijZ3e1kiWLAwcOHDhw4MCBA0xGo3F8z2gkxWtlNM2KslbmMaquinw6Fq+IcVbW2jxJvcjiV+BUPKu0YVIXU48VyXShjSVV5mXYyawyGKrwTVBcGRfqNBC+IGfaOFPG4hlegy0PqFTs55VpuUPtC7hXqOUONevQ44mW46N5kSfJJLonSfJ8vjryM96Cp7ToZZGEUnQSRtnyyC89crbfkSIJnv98lK/MPhYDh9tE7fFklUnBRU7mynQzE8MRLPaEVySFJdEeQSoSAzHRpgPiiq0g08V7MQSy7LKliFy8TlSXPQNkT6g6tLyTwpFk9TuyJ2NowYg69JRygChjaEGI1KDRFtQsLTi/5o+eDJcyq96H7t1QyRPrIeaEYDmInDdmh0IKACDcStE7M9gY9352IXsXg/8D9+yp5YuKeStelkABckAxKhygsQXkQA1AHQgUPNrKF6pmH6QYhLcvIifUhvJOQLivPGb9JyQuxr35yIQzEhbT/0hGwpUFLKZ/OTpwrc2omP7luNfpCSCmXwLd22ZBoIYRwy+pbwROZQiF+D0k/NThJ00tAPrvCio4zrAVev8Ufcw6CnS4f2r3XzIDlgBDFLYK/Qb3CiDHaV4uqp+URRaPBUjkGmtzmjQSUpIWyjxGL9LAOXW0FLZMDSEApEyrXh+n105zqGJMm/BD99I+5EJDiBymLIVr6fHxWe5QCJRDnGXaMCgDh58UwdW5AHbDOKgUr2sV2m2qADCGRynhKhuB1liNoHxvGIAjJTVmDrUGeCTCR4VoIYiggpZiAUrZtpvN5rY1nbxBzUGsWbmJ2W4uTtfN/3w+v25RObg5CZZt8hcxm4t1s8PptdklxMwpBY8Ks6be1XLadPHxamsMupzMrbu1gGYNvPN+S7Ts6tnxR0nInNy2rCurVohy1TzFaWsoJWSOsq0BKVgBWmJMtz0bcE9WarucjiFr5obQfmye5cpgK5alXcs1RyIgYYqhcrBYi+zGQCO1UzHFUP7CViy1zYdiZActYYuhbKCmOCeO2gRaCllz1nBZt4g5koSazQ8LEGu+NXxOIXMq/hCEpA9Avr8lvYxd6kjgmXLB/9MM2eE9b2xYkyYnB/5dxR/mENjrahs7rpDJrWYbCn07Yg01Bx+9Kbc+l4DzbWPLNyCyI27iZEQ2UNGuG4JtWauAXq3idkEB0KJ9aax5CDUN1FAteSlQA2mzbRqXUBsBiRPy5tmlIDALxz+AmnOg95jyPhMDOUnm26+AmhNkguOVgQzom8gI/NEAIMsCXhkogEYjoUUAoLVWQ4uV4hULAag5aQA2jMYQG/WafDOw3miGUpOxihqJYa/VkKI25RToHBmntasaoKilnGKbep03rGGPHR8ofHaraUvBRjNSIkG2a0K6HgCAHkke26kZATFM9gSgJjpDjpqtOOVJIK7fAGouSHQjamqeGqSHBora38AahK5CVM9qip7WN0pAarC/4WTbj8aWM7IG8UKNNDTU8EBLvVBDd60u8dWNCfxQk+HmfAe2VpEqgIWauYStST1RQ0Nta9Wr/UsfLfmiJjIP3GAzpynB8VuxOhvUHHMJxZkJ/FETGcIXrpgWtYZ2nUveigA2Z8tbGKxvGdYAKwJ4tUY/yZVDxeDnYMlqjbmkw4/6b8+eD7NHYpSABy9jGYhcb+OXgi+t4cUZnhI0uSrHe5Q3J09F2aUxjDgDdqAYe4jQZdPtJdcYs3A5hy+Bv0Iunrd/nnRquTHAgS5gTxbYVad8MDtsv+/OPZ8ut328SESzetWI1gpYDmV78/Xs051H65Ozix8tcIgYf+Ih6eQMyeGDixFT5qAfQ2WA5g4f/HJ/wUyIOVoGaGXj80G6XtzkFvIUvvDKRb8VGGTBih0s6D/a8Ff7xOwfqUnioAQrjjFs7/GTKTQkR729YIf3Xi/o1BBwogsgWhoC4zV40GxT81eRlXAiSEjAub4Gj5JY5LbusBEXND8ylON5FgoA9CSkKLpDDSeMkiz/STIJpeiBYGeRxw81HyGZXVoe1PcQZXWErqBJ5h/0moPlQX0PX0lve81B0zrgG4GxTITc5zrw3nbbShqP64D9VafKX3MS+024yF9zFLDUV76aQ60JsSuvOKM4zfKyXFT3lGWep/FY9mPNCruPjOlIi4Uy3eiqyGJAE3y1Pjf4nCPjotLmWeoyDYB30kAHGjTYEIxn/7V3trtpw1AYHlZE2WiT0FSIj7pxglqUNWwMxmBdByLx/V/Ttu7PaZrQ+I1NQ5XnBtCjc2yh2H7PUJZnrDa8o4+eYPeQvJUzj0tV/KuPyIkXV2sXX3UjaDlcYvglK8RpafCvfGPjAz34OVPaAkZV0nl6x5h/wxTiz1ilHCkLcNHsw6vFqg4LD4xwF9zHqXpI4tN9DXdJk2T3RJLgPh1JOK/8uf9TqdkklHT/MItvQ0EJbqez9e6glcNe+1TPqydC+kwlImm/jg+eSU8Xu1QlUGkMbwG01w4tHaeoJuvPgSjBX6Oy7XapJTX0ojha0hrLPJLlVJRnEucL+baRoM1hUT6DnV8VolJaKHmtPJ0ScTFAyKyTu2JoFA/E9NfBaT6Wn9nPcNoyR8fiOS5TgTPJ83HIdqbre6X78hdswAXxuWy9kOFa0q6pjgO4YD5jlpVhmpPInStJIEk8Jnz4GUfyr/Aj83QZCG3EiTzEhe646Sy7idDKUhbjGoibpqRfhG4mheXxDExtKJmQhBP8KLjEYiA9m/IzEEb4KglA2j2kA3QZ0G2ADKLzTZhjkmIyuE4SCVOEW3gQEr4VfA+FEWYpsAFUHx2Z3BsrDMU1OVODstFdnmCeYv8AcB3KXKtPlACT/WBanpTm2u1ue+wZn64EfAAXcDPDu436hFpc4CWDw/oyh02oY+3j2dG6b21u7wOwLL+JCzDUUWd5KJtIXWWVGp/AjF+qfVRYQgFRyeAihcFpubKI/SYKS5jMtylw7/u47UYfqoh8yNMVg02GzxgudnpcLWZxdPePKI4Xq4dtAt77Ps7yUaS+Lk8+o/fjQobCV2dk1+IaKetzDS41ugnXHVRTcWtRlswjCIgbt0ZloUIDX70q1of60u6NShtde52aNVgeVtcrUKJPV9onYEIeqtjeYHSTtbge9O2udUoiz2Gs/R/GTleioaGhoaGhoeEN+ANRY/FEMaPNiAAAAABJRU5ErkJggg=="
              alt=""
              class="sup-items-img"
            >
            <p class="txt">ログイン</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-payment-method"
          >
            <img
              src="data:image/png;base64,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"
              alt=""
              class="sup-items-img"
            >
            <p class="txt">ご入出金</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-account-binding"
          >
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGcAAABmCAMAAADhw39uAAAAt1BMVEUAAABAQEBAQEBAQEBAQEBAQEA+QEBAQEBAQEA+QECxp4GVjXJAQEBAQEA+QEBAQEBAQEA/QEBAQEA/QEBAQEA/QEBZWU9AQEA/QEBAQEA/QEA/QECxp4GqoX2qoH2poH2jmnmclHWck3Wbk3WVjXGUjXGNh22Nhm2GgWmGgGl4dGB4c2FxblxxbV1xbVxqZ1lqZ1hjYVVcWlFcWlBVVE1VU0xUU0xOTUhNTUhHR0RGR0RGRkQ/QEDFQZARAAAAHHRSTlMAECAwQFBfYHB/gICAj4+Qn5+gr7+/z8/P39/vkMbNIgAAAtxJREFUeNrt2e1O2zAUgGE7cXDZ0mWhZHR2gIzRreyrDDZaxrn/61rtNj3MTtXUPZmElPdvfzyyYzVHDuvr6+vr21Ys0zzPh2kSd4iIXMMmlYtuFKnASUl6JSqgoSIiZmINjSlByhxBnT77OZvd/ULpqANGZ4Kx0jaZwSodkzMpZ8w6tmotqYiW0YLZyk2TRzAVlAzuT4l9WEEDesY62CcwaU7KoIN9B1NKzPjO+RwXRMagg91QPKEIGcfB5gRHLvUY3/kKJn6QM/AY3zkn2Dg+RgYdpzvj5OywEsmZ7/hHWzHifGdqHN29c0VwEDjf7VTWiUKFZDjWdueLVHTmiEI7A8d2ZwImHqQAhhLxOeAjaKqItji3sOx0b0ZoaE7Fjc65fddl+zLHUHeWSbFssFmePtr+/ybCGDvZ1EX1JKq571R/7FoDmZyz5/EMbNJzLhb1DwGMFswt0Zvd+Yd5AJMKYZoHsljVY4DPgKBhbFzgeXOYlJDBumWwbhmMgpm/ZjujYKpXLZyDmd8XZQuHgmnjEDAtnWpxGNPOIWBaOQRMGyciYFo4kSJg0IkFJ2QEMuisfRWTMUzVDDro66RhRgliJJjmNYOOBNsb5+39FmomYDmPVek5XNfTYYRrGWpkAp7Ol9J3mNSwbjQQy+RwDBDIsAyWPV06Do4DjWnB9q2AZbPSc/Bez2/E2d7ZvblxHf+eEjsVbP84mK49Z5ukUQm4hKgaHEykxXtrnGUJZxihg3FHCNq3K9chDc/BtHtHGefHLofL5EDnxDj3nuNfXI8Jbong0nFchuCWaPv/GzIU95IFLFu4js9AxAg2buo4PiNZePiaWVw6Di2D95LfHIeWwQXBZ8ehZfAJPX1Eh5TBihV07TqClMGB7LZ67vBjIGRwf6x0bR2cbJAhScKmh/vZu9HYIsiQJRQ0puP/8snyNHqpn2BN4gQp0Llg3RUnaZbneSpj1tfX19fX2F+To2WpvfC6LQAAAABJRU5ErkJggg=="
              alt=""
              class="sup-items-img"
            >
            <p class="txt">出金アカウント<br>の紐づけ方法</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-wallet"
          >
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAADMCAMAAADnPtf+AAAAsVBMVEUAAABAQEBAQEA4QEBAQEA6QEBAQEA8QEBAQEA9QEA+QEBAQEA9QEA9QEA+QEBAQEA+QEA+QEA+QEA/QEA+QEA/QEA+QEA/QEA+QEA/QEA/QEA/QEA/QECxp4GqoH2jmnmimnmblHWVjXGUjXCNhm2NhmyGgGmGgGh/emR4dGF4c2B3c2BxbV1xbVxxbFxqZ1hqZlhpZlhjYFRiYFRcWlBbWVBVU0xUU0xNTUhGR0Q/QEBF8Dp3AAAAHXRSTlMAECAgMDBAQFBQX2BgcH+AgI+Qn6CvsL/Az9/g76i/bl0AAAQRSURBVHja7d3hdtJIGMbxdyKS1jZoJ1AgzQBCF2pdd7Fu1+S9/wuzqSdMKmYCHD/MM33/N9DzOw8N0IyRJEmSJEmSJEmSJEmSJOmQYp1+iCiI1CDnqneEXzzmuj5hV81iGxNy9Sx1OcH2ZjeLjTBT59UsYWh61SxhaH7OEoYmrmYJQ6OSapYwNLHOmcPQtM8y6V+AaVpnyd8rIiiNaxYigtK4Z4HSdMwCpXHPAqXpmAVK454FStM6S/48C5QmTltmmVazQGnUYNoyy3U1C5QmHrlmgdK0zzKsZoHSxOOWWSaJIoLSqEELJdfVLFCaeMyOWaA0HbNAadyzQGk6ZoHSuGeB0nTMAqVxzwKl6ZgFSuOeBUrzpnWW99UsSBp13jrLmSKC0vTaZ+kREZKmYxYoTdw+S0RESJqOvyNBadx/R4LSdMwCpXHPgqSJEz3mlrL0z2d/WLqfTmI6vUjn7FlZGtFJqSv2sit1yjAZe1p2/Dw9715ktrx37DIeY544x62jvH2Z/SxTdESeXgBsV3R4EXtfRAc3ZFv5betJ3wq2aTq4jOuKlfGoTXHCScnYYhbGqxbF8YdyE67bGM9acV1CB6Z3F0LjXaXrF8d9Ebg23vWw+4x9tCY13rUVjWhEIxrRiEY0ohGNaEQTpmZ+e3e/7apA0Cw//VfyQXmvWX55loSgmd39z8yBaD6VzKFolgVzKJrZ38zBaD4WHI5mzRyO5jPvl99MrofuMi81e5gbfRFRd0MfNXe/PXEIqvm4f8IFVzMvuJFWRMiaf9mW9YmgNWu2TRWBawqLGSkC16xfLIOueWye/0HXzHnXJcFrvjg/aqnBOOd8dI6i+e46XXKW1z86gtDMuG5Ce73jXZlC0Ky47tJ9Km6EoNk4XmhDbtYH0Nw7zv3k3EwjaSb0az1+0RRAs23XxPyiDECz22batc0ESZPRrym835sN16mWo2R1PQDNLdf13e83KcL7zZzrPrj+wQpnEYLGFK4HjJ5l9SVAQXxOM1vnm310MWG+ue6jfIbesB0H//vNrOS6BF/T+LqW43+TNqvmhQteYx6bHHjNomxy0DUvb3cM0DXmOzfKLsE1i5KbZelbZI29gWNBl29hNb+/h5uNx6PUnZ/3Pc1tGdI9abMoQtKYxdeQNMZsipA0ZvG5CEjz5LkrAtI89dfXMiDNU6v7xzIcTdVstbn/J4wzt+GdhxaNaDxKNKIRjWhEIxrRiOa59HU+M0Xv7n0Z7yqOfp5NwnVL41nr4++Z9rmumBuvmp/wHCjKLWdtPGppMRkdnGZb8bD1pIeSbelrfbYdafY8/XqfCRnW8zoDe5ZqYM+5JVKeXgq0opOKht7tk+uITq+f6KE36QT9/5qXJEmSJEmSJEmSJEl6df0ACttE0yZXl0EAAAAASUVORK5CYII="
              alt=""
              class="sup-items-img"
            >
            <p class="txt">ウォレット</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-event-bonus"
          >
            <img
              src="data:image/png;base64,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"
              alt=""
              class="sup-items-img"
            >
            <p class="txt">キャンペーン</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-verify-your-account"
          >
            <img
              src="data:image/png;base64,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"
              alt=""
              class="sup-items-img"
            >
            <p class="txt">本人確認方法</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-about-shop"
          >
            <img
              src="data:image/png;base64,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"
              alt=""
              class="sup-items-img"
            >
            <p class="txt">ショップ</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-coupon"
          >
            <img
              src="data:image/png;base64,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"
              alt=""
              class="sup-items-img"
            >
            <p class="txt">クーポン</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-vip-class-upgrading"
          >
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABECAMAAADgDwi+AAAAw1BMVEUAAABAQECvp4BAQEBAQEB4dGBAQEBAQEBAQEA+QEBAQEA+QEBAQEBAQEA+QEBMSkdAQEBAQEA/QEBAQEBJSkZAQEA/QEBAQEA/QEBAQEA/QEBAQEA/QEA/QECxp4GqoX2qoH2poH2jmnmck3Wbk3WVjXGUjXGNh22Nhm2GgWmGgGl/e2V/emV/eWV4dGF4dGB4c2FxbV1xbVxqZ1lqZ1hjYFRcWlFcWlBVVExUVExUU0xOTUhNTUhHR0RGR0RGRkQ/QEDwW410AAAAHnRSTlMAECAgMEBAUGBvcH+Aj4+QkJ+foK+vr7+/z8/f3++hkHzNAAACfElEQVR42u2WYXeaMBiFwTBkwLpKN2tbyFY2dWXWtdK6rrqN//+r9pKglwQXeuRbD/eDQiRPeC4cxOrT55XGDsYTz+4IcZKCErNOEBYXIpedKCMiXGzow+/iU9oM0t9FkXSopvRxBvyOvqKjIW/F7AHnT7Thdqg2ZiVl1qHgkWyVKDw/uuBhWa0lKZ9Q8DHVVhR++7KCbVerL5DzJAUFKzNsjTEuTz9gGGFJWS0oesFsVFAChXJJI+CgWlBQMBiUEwvxCgo4qBYUWTBTGarlR5oy9GJwRLUMlF3B4xpjPb9Vr/9EOoMjqwUFBe8ZMxqh7xCUU9qlvsGR1YKyLzipMfictjxQXHlq4OBn13+/vElRMBicPwhthJaYWBRwYsmoLt7PtCoYDArtnoMBJXDEGifFPj9kwZIBQwhBCZywun2RjFPuwYAQAiXtLlqRy6ws5O8117KthJAzKCk3dMZF7qQTAiGTEoXRUM6rrOlkAFCFEBtK9efLlFdZ0E5qEIJSoiqFNFE5/alBCEraoE8j1xrFJAQl3WiOOUA2hZAJlMB9rmamNOepIeQ3KR6Uajf0Y7qDFJlZCEtHjZFiu8qy1R/a2GhXCA9QgxJeO2Q2qQL5AqGmkmupmHgHWQsIci+FzEpAXwgGOtGFzEqAv0k/cwRCp4cpflMJT8ymkHOYYmOBNsov8TD8v9KLKCnWa1Vijhe+i6IPeZ4vl9+mtXYWEDIqucE4KbRsH79/bRWCkhuBoJMeCJTK/zyT0jCoI5IrkTro+WYB88NKyFXkD5m9/8UZhnAUQiYlmXOfYRBx/N0BYesbexLahiPOxCq2ZYwX+i1HMD90rT59+tTyD2tC6AZPcnR4AAAAAElFTkSuQmCC"
              alt=""
              class="sup-items-img"
            >
            <p class="txt">VIPに<br>アップグレード</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-faq"
          >
            <img
              src="data:image/png;base64,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"
              alt=""
              class="sup-items-img"
            >
            <p class="txt">よくある 質問</p>
          </a>
          <a
            class="sup-items"
            href="https://www.katsuwin.ai/page/sup-self-restraint"
          >
            <img
              src="data:image/png;base64,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"
              alt=""
              class="sup-items-img"
            >
            <p class="txt">自己制限</p>
          </a>
        </div>
      </div>
    </section>

    <section class="registration">
      <div class="registration-inner">
        <h2 class="tittle3">
          まずは無料で登録！
        </h2>
        <div class="flex-container">
          <div class="flex-row">
            <div class="item-box1">
              <span class="point">新規登録特典</span>
              <h2 class="point-tittle">
                <span class="big">{{ bonusAmount }}</span>円分
              </h2>
            </div>
            <div class="item-box">
              <h2 class="point-tittle">
                無料体験ボーナス
              </h2>
            </div>
          </div>
          <div class="flex-row">
            <div class="item-box1">
              <span class="point">初回入金特典</span>
              <h2 class="point-tittle">
                <span class="big">50%</span>
              </h2>
            </div>
            <div class="item-box">
              <h2 class="point-tittle">
                キャッシュバックボーナス
              </h2>
            </div>
          </div>
        </div>
        <div class="btn-cover2">
          <a class="btn btn-block btn-xl btn-primary" @click.prevent="redirectToHome('register')">
            <span class="btn-content">今すぐ登録</span>
          </a>
        </div>
      </div>
      <img class="side-phr" :src="$getThemeImagePath('9_gift.png')" alt="">
    </section>

    <section class="conditions">
      <div class="box">
        <div class="center">
          <h2 class="conditions-ti">
            利用規約
          </h2>
          <h4>最終更新日：2024年7月26日</h4>
        </div>
        <span class="title">利用規約と条件：</span>
        <br>
        <span class="num">1.</span>
        勝winにご登録のお客様は全員、利用規約に同意する必要がございます。利用規約およびそこで明示的に参照されている文書は、両当事者間の完全な合意および理解を構成し、当サイトとお客様間の契約関係を規定します。当サイトをご利用の前に、これらの利用規約をよく読み、ご理解いただきますようお願いいたします。お客様がこれらの利用規約に同意しない場合は、当サイトを利用しないか、ご利用を継続されないようお願いいたします。また、当サイトのプライバシーポリシーをよくご理解いただいた上でのご利用をお勧めします。
        本ページは勝winの利用規約(以下「利用規約」)を構成しており、当サイトに登録のお客様全員がこれに同意する必要がございます。これらの利用規約およびその中で明示的に参照されている文書は、
        当事者間の合意および理解を構成し、お客様との契約関係を規定します。勝winをご利用の前に、これらの利用規約をよく読んでご理解ください。これらの利用規約に同意しない場合は、当サイトを利用しないか、ご利用を継続されないようお願いいたします。また、当サイトのプライバシーポリシーをよくご理解いただいた上でのご利用をお勧めします。勝winはライセンスを取得しており、コモロ連合アンジュアン自治島政府によって規制されております。
        勝winは、Initial Singularity
        Limitedによって所有および運営されております。 登録番号: 15679
        登録住所: Hamchako, Mutsamudu, Autonomous Island of Anjouan Union of
        Comoros.
        <br><br>
        <span class="num">2.</span>
        勝winはライセンスを取得しており、コモロ連合アンジュアン自治島政府によって規制されており、ライセンス番号:
        15679に基づいて運営されております。勝winはすべての規制遵守条件を満たしており、あらゆる賭けとギャンブルのゲームの運営を行う法的権限を与えられております。
        <br><br>
        <span class="num">3.</span>
        これらの利用規約に同意し、当サイトにアカウント(以下「アカウント」といいます。)を登録することにより、お客様へ以下のことを表明および保証いたします。
        <div class="en-box">
          <span class="en">a.</span>
          自身の名前でアカウントを登録します。
          すべてのユーザーアカウント情報など(アカウントナンバーとパスワードを含む)、および/またはサイトを通じてユーザーアカウントにアクセスするその他の方法については、お客様が単独の責任となります。お客様がアカウント侵害の被害にあったと認識された場合は、ただちにサイトに連絡し、アカウントおよびアカウント残高への不正アクセスを防ぐための適切な措置を講じる必要がございます。
          <br><span class="en">b.</span>
          お客様が満20歳以上であること。
          <br><span class="en">c.</span>
          20歳未満はカジノを利用することが禁じられています。上記の規定に違反していると考えられる場合、アカウントはただちに閉鎖されます。
          <br><span class="en">d.</span>
          当サイトではお一人につきひとつのアカウントのみ作成できます。
          お客様が何らかの原因で複数のアカウントを開設したまたはしようとした場合、当サイトの裁量により該当のアカウントの一部または全てをブロックまたは終了させる可能性がございます。当サイトを閉鎖し、全ての賭け(決済済みまたは未決済)をキャンセルし、引き出し可能な資金を没収または返金する場合がございます。
          <br><span class="en">e.</span>
          お客様は、他の誰かの代理などではなく、自分自身の立場でまた自分自身の楽しみと娯楽のためにのみ当サイトを利用する必要がございます。
          <br><span class="en">f.</span>
          一部の司法管轄地域では、当サイトへのアクセスや利用が違法とみなされる場合がございます。
        </div>
        <br><br>
        <span class="num">4.</span>
        勝winは、適用される法律、規制およびその他の規制要件の遵守を含め、利用規約をいつでも変更する権利を有します。などしたがって、当サイトはお客様と勝winとの間の本規約をいつでも変更することができます。
        利用規約に重大な変更があった場合には、サイトに通知を掲載いたします。お客様が改訂された利用規約に同意されない場合、お客様のアカウントを閉鎖いたします。有効なアカウント残高を引き出される場合は、カスタマーサービスにご連絡いただく必要がございます。
        <br><br>
        <span class="num">5.</span>
        アカウントを作成するには、携帯電話番号、パスワードなどの個人情報を入力し、登録完了後に名前、生年月日、住所などの個人情報を追加で入力してください。
        <br><br>
        <span class="num">6.</span>
        アカウントの名前と住所は身分証明書および関連確認書類と同じである必要があり、身分証明書の住所は住所確認書類と一致している必要がございます。当サイトではお客様の本人確認のため、いつでもお客様に本人確認書類(パスポート、身分証明書、住所確認書類、有効期限内の支払いが可能なクレジットカードなどを含む)の提出をお願いする権利を有します。身分証明書を提出できない場合、当サイトはお客様のアカウントを一時的に閉鎖する権利を有します。
        <br><br>
        <span class="num">7.</span>
        ご登録の際は正しい個人情報をご入力いただき、登録情報に変更が生じた場合には随時登録情報を更新していただきますようお願いいたします。上記の行為を行わない場合、アカウントの閉鎖、アカウントの利用制限、入金(ボーナスなどを含む)の無効化などが発生する場合がございます。当サイトは、いつでも理由のいかんにかかわらず、いかなる人物の口座開設を拒否する権利を留保します。
        <br><br>
        <span class="num">8.</span>
        VPN、プロキシサーバーなどを利用して実際の位置情報を隠すことは禁止されており、お客様が制限区域から当サイトにアクセスしていると判断した場合、当サイトはお客様への事前通知なく直ちにアカウントを閉鎖する権利を有します。
        禁止地域：お客様が米国およびその領土、マカオ、スイス、アイルランド、シンガポール、ハンガリー、ミャンマー、ルーマニア、ベルギー、デンマーク、フィンランド、ドイツ、イラン、イラク、イタリア、ミクロネシア、ノルウェー、ポーランド、サウジアラビア、オランダ、プエルトリコ、イギリス、フランス、香港、台湾、北朝鮮、イスラエル、キプロス、エストニア、フィリピン、トルコ、スペイン、ブルガリア、アンティグアバーブーダ、キュラソー、法律または地域の条例によってオンラインカジノが禁止されているその他の国にお住まいの場合、勝winはご利用いただくことができません。
        <br><br>
        <span class="num">9.</span>
        全てのお客様において、IPアドレスやデバイスごとに登録できるアカウントは1つのみです。また、1世帯につき1アカウントとなります。お客様が複数のアカウントを所持していると当サイトが判断した場合、独自の裁量により、重複したアカウントをブロックまたは閉鎖し、該当アカウントのすべての賭けを無効とする場合があります（決済済みのものを含みます）。さらに、引き出し可能な資金についても没収または返金の対象となります。
        <br><br>
        <span class="num">10.</span>
        アカウント情報は登録プロセスの一部であり、お客様は当サイトにログインするためにアカウント番号とパスワードを選択する必要がございます。ログイン情報のセキュリティを保護するのはお客様の責任であり、お客様はご自身のログイン情報を決して他人に開示してはなりません。当サイトは、お客様のログイン情報を第三者への開示など(意図的か非意図的か、積極的か受動的かにかかわらず)による第三者によるアカウントの悪用について責任を負いません。
        お客様のログイン情報を使用して行われるすべての行為は、お客様ご自身の行為とみなされ、そこから生じるすべての責任はお客様が負うものとします。
        お客様のログイン情報が第三者に知られた場合、お客様は責任を持って当サイトに通知し、ログイン情報を変更するものとします。
        <br><br>
        <span class="num">11.</span>
        当サイトは、理由を問わずいつでもお客様の身元を確認し、関連書類の提出を要求する権利を有します。これには法律で許可されている身元調査、信用調査、個人履歴調査が含まれますが、これらに限定されません。このような調査の基準は状況によって異なりますが、名前、住所、年齢、職業、金融取引(お客様の財務状況や資金源など)などを含むお客様の登録情報、および/またはお客様のゲーム活動記録などの確認が含まれる場合があります。
        勝winには、調査が進行中であることをお客様に通知する義務はなく、調査には認可された信用照会機関、身元確認サービス、および/またはお客様を確認するための不正防止機関など、調査を実施するために特定の第三者企業の利用が含まれる場合があります。これらの調査の結果が否定的または不確定の場合、勝winは独自の裁量でお客様のアカウントを閉鎖し、すべての決済済みの賭けをキャンセルし、すべての残高を保留することができます。すべての個人情報は、当サイトのプライバシー
        ポリシーに従って取り扱われます。
        <br><br>
        <span class="num">12.</span>
        マネーロンダリングを防止するため、当サイトではすべての支払い取引をチェックしております。勝winおよび規制‧管理機関は、犯罪防止の目的ですべての取引の監視または調査を要求する場合があり、勝winでは疑わしい取引を関連当局に報告します。
        さらに当サイトのゲームに関連して不審な行為を発見した場合、直ちに関連当局に報告し、勝winは適用されるマネーロンダリング防止法およびテロ資金供与対策法に従ってアカウントを凍結または閉鎖、およびすべての決済済みの賭けのキャンセル、および/または口座残高を保留にする場合がございます。
        <br><br>
        <span class="num">13.</span>
        お客様はいつでもアカウントにログインし、入金、出金、報酬記録、ゲーム記録などのアカウント履歴を表示することが可能です。エラーを発見された場合、必要に応じて調査および修正できるよう、ただちにサポートに連絡する必要がございます。
        <br><br>
        <span class="num">14.</span>
        クレジット、ボーナス、またはその他の資金が誤ってアカウントに入金された場合、お客様はメールまたはチャットを通じて勝winにただちに報告していただきますようお願いいたします。
        誤って入金されたすべての金額は勝winの所有物となり、お客様はご自身のアカウントからただちに勝winに返金する必要がございます。お客様が誤って入金された資金を引き出した場合、お客様は勝winの清算債務者とみなされ、引き出した金額を直ちに返済しなければならず、誤って入金されたポイント、ボーナス、またはその他の資金を使用して行われた賭けは無効になります。
        <br><br>
        <span class="num">15.</span>
        12
        か月連続で取引活動がない場合、アカウントは休止状態とみなされます。
        アカウントが休止状態になる少なくとも 1
        か月前に、勝winはお客様にメールにて通知を行います。お客様は、アカウントにログインすることでアカウントを再開できます。アカウントが休止状態とみなされた後、勝winがお客様と連絡が取れなかった場合、勝winは、お客様のアカウント残高の5%または管理手数料として月額150円のいずれか高い方を徴収いたします。
        休止アカウントの管理手数料により、残高がゼロになる場合がございます。手数料を返金を求める場合は、口座休止期間中の健康状態不良またはその他の正当な理由を証明する書類を提出する必要がございます。アカウント残高の額面に関わらず利子は発生いたしません。したがって、お客様は勝winを金融機関とは見なすことはできません。
        <br><br>
        <span class="num">16.</span>
        勝winはお客様による不正行為や共謀行為などを厳しく禁止します。
        詐欺または共謀行為が発生したと合理的に判断された場合、当サイトは行為の結果として、行われた賭けをキャンセルし、および/またはお客様のアカウント内のすべての資金を没収して閉鎖する権利を留保します。他のお客様が詐欺または共謀行為によって不正な利益を得たと疑う合理的な理由がある場合は、メールまたはチャットを通じて勝winに報告する必要がございます。
        <br><br>
        <span class="num">17.</span>
        他のお客様のアカウントへの資金の送金、およびその逆の行為も禁止されております。
        <br><br>
        <span class="num">18.</span>
        お客様は、いかなる方法であっても、当サイトに侵入したり、当サイトのコードを変更したりしないこと、また当サイトの抜け穴を悪意を持って利用したり、お客様またはいかなる第三者が当サイトをご利用の際に、ボット、自動機器、機械、電子機器、その他の機器を利用されないことに同意したものとみなします。上記の機器またはお客様に不当な利益を与えるために設計された外部リソースが当サイトで利用されたという合理的な理由が当サイトに発覚した場合、上記の機器によって行われた賭けは全て無効とみなされます。当サイトは独自の裁量により、調査中のアカウントを一時的に凍結または閉鎖する場合がございます。当サイトでは、上記の機器の使用は詐欺に相当するとみなし、この場合、残高を返金せずにアカウントを閉鎖する権利を留保します。
        <br><br>
        <span class="num">19.</span>
        勝winは、日本政府または外国政府の要職(PEP
        )に就いているお客様にはサービスを提供いたしません。お客様がいずれかの段階でPEPであると判断された場合、お客様のアカウントは閉鎖されます。当サイトによって行われた
        PEP
        の決定について不服申し立てを行う場合は、メールまたはチャットで当サイトまでお問い合わせください。
        <br><br>
        <span class="num">20.</span>
        お客様は、お客様のアカウントからの入出金には、正当な機関によって発行されたお客様ご本人の名前かつ有効なクレジットカードおよびその他の支払い方法のみを使用することに同意したものとみなします。お客様の支払い名義がお客様ご自身のものではないと当サイトが判断した場合、当サイトはお客様のアカウントを閉鎖し、すべての賞金を無効にし、カード会社に発行されたカードの使用を禁止する権利を留保します。
        <br><br>
        <span class="num">21.</span>
        お客様は、ご自身のアカウントから資金を引き出す際、任意の金額を入金し、KYC
        本人確認を完了する必要があることに同意します。最低入金額は、当サイト内にあるお客様のアカウントの「入金」ページでご確認いただけます。
        <br><br>
        <span class="num">22.</span>
        勝winは、引き出しを反映する際にかかる合理的な手数料を請求する権利を留保します。さらに、当サイトでは管理できない追加の外部銀行手数料がかかる場合があり、それらの出金手数料はお客様のアカウントの「出金」ページに表示されます。
        <br><br>
        <span class="num">23.</span>
        不正な手段で入手した資金は違法です。適用される法律に従い、勝winは可能な場合、資金移動にお客様と同じキャッシュフローを使用します。入出金は登録されたアカウント所有者の名前でのみ行うことができますが、勝winは強制的に外部との接触を遮断した管理を行うか、お客様に特定の支払方法での資金出金を要求し、出金の取り消しを行う権利を有します。
        <br><br>
        <span class="num">24.</span>
        お客様がクレジットカードまたはデビットカードで入金する場合、当サイトはその裁量により、セキュリティコードに加えてカード番号の最初の6桁と最後の4桁を示す両面画像の提供をお客様に要求します。
        (例:CVV)。 <br><br>
        <span class="num">25.</span>
        アカウントから資金を引き出すには、お客様はゲーム内で少なくとも入金額の2倍の最低金額を賭ける必要がございます。勝winは独自の裁量で不十分な賭け金に基づいて出金申請の支払いを拒否し、特定の条件下でお客様に対し、賭け金を上げてプレイするよう要求する権利を有します。
        <br><br>
        <span class="num">26.</span>
        無料のベットまたはボーナスは、イベントやプロモーションの一環としてお客様のアカウントに入金される場合がございます。これらの無料ベットやボーナスは当サイト内で利用必要があり、そのまま出金することはできません。
        イベントやプロモーションに応じて、これらの無料ベットとボーナスは、各イベントまたはプロモーションの特定の利用規約を満たすことでリアルマネーと引き換えられる場合がございます。すべてのイベントまたはプロモーションにはボーナスルールと利用規約が適用されます。詳細については、ボーナスルールと利用規約をご覧ください。
        <br><br>
        <span class="num">27.</span>
        お客様によるアカウントへの入出金は、金融機関または決済サービス機関を通じて行われます。入出金の手順、利用規約、可用性、手数料、処理時間は、関連する金融機関または決済サービスプロバイダーによって異なる場合がございます。
        <br><br>
        <span class="num">28.</span>
        当サイトでは掛売りはできません。アカウントに十分な資金を維持し、それに応じて賭けるのはお客様の責任です。口座残高が不十分な賭け取引は無効となります。お客様のアカウントの資金がすべての賭けをカバーするのに不十分な場合、当サイトは不用意に行われた、または受け入れられた賭けをキャンセルする権利を留保します。清算機関による入金キャンセルによりアカウントの資金が不足した場合、勝winは受付済みのすべての賭けを遡り、当該の賭けからお客様に支払われた資金を払い戻し、無効にする権利を留保します。
        <br><br>
        <span class="num">29.</span>
        KYC認証が完了している場合、出金承認は原則として数分程度で完了いたします。
        ※ただし、ゲームプロバイダーのチェックが必要な場合や、提携決済会社のメンテナンス、お客様の受取先口座のメンテナンスなどにより、お時間をいただく場合がございます。
        <br><br>
        <span class="num">30.</span>
        お客様のアカウントへの入金は、お客様のゲームプレイに対応している必要があります。当サイトがアカウントの悪用を発見した場合、勝winは独自の裁量でお客様のアカウントを閉鎖し、アカウント内の報酬とアカウント残高を没収する権利を有します。これらの不正利用には、出金リクエストを申請する前に入金額を賭けなかった、または不正な利用などが含まれますが、これらに限定されません。
        <br><br>
        <span class="num">31.</span>
        当サイトは、いつでも取引およびゲームの記録を閲覧する権利を有します。再調査後、当サイトは独自の裁量により、不正行為を用いてゲームをプレイされたお客様に対する報酬、ボーナス、リベートを取り消す権利を留保します。
        <br><br>
        <span class="num">32.</span>
        お客様が実際のボーナス額を超えるボーナスを獲得するためにイベントまたはプロモーションにおいて不正行為(以下の内容を含む)を行った場合、当サイトはただちにお客様を今後のすべてのイベントまたはプロモーションからの参加権利を剥奪します。
        <br><br>
        <span class="num">33.</span>
        ベットにおける禁止事項・全てのルーレットにおいて、一度に25個以上(25を含む)の数字にベットすること。
        <div class="en-box">
          <span class="en">a.</span>
          全てのゲームにおいて、ベットカバー率が65%を超えた場合
          <br><span class="en">b.</span>
          全てのゲームで、1.5倍以下の配当のベットを繰り返すこと。
          <br><span class="en">c.</span>
          フリースピンを貯め個別に入出金を行って現金を受け取るなどの行為を含むキャンペーンなどへの投機的な参加をすること。上記の行為が発見された場合や、ボーナスや特典などの悪意のある利用が発見された場合は、当サイトは直ちにボーナスおよび特典の権利をはく奪し、アカウントを即時閉鎖する権利を有します。
        </div>
        <br><br>
        <span class="num">34.</span>
        現金ウォレット計算方法：
        有効となるベット額は勝利または負けた時のみ計算され、2ティアベット・引き分けの場合は計算されません。
        ゲームに負けた際、ベットした金額が反映されます。
        ゲームに勝った際、勝利金がベットした金額の75％以下の場合、勝利金額分が反映され、勝利金がベットした金額の75％以上または同等の場合、ベットした金額が反映されます。
        上記内容はテーブル・ライブゲームおよびクラッシュに適用されます。
        スロット・フィッシングゲームではベットした金額が反映されます。
        <br><br>
        <span class="num">35.</span>
        以下の行為が認められた場合の規約と条件：
        <div class="en-box">
          <span class="en">a.</span>
          第三者への情報の開示
          <br><span class="en">b.</span>
          バグ、脆弱性、ハッキング、コンピューター攻撃、その他の不正行為(詐欺)や自動化されたゲーム(ボット)を悪用して、不当な賭けをすること。
          <br><span class="en">c.</span>
          不正コピーまたは不正利用されたクレジットカードまたはデビッドカードを使用して賭け行為を行う。
          <br><span class="en">d.</span>
          ゲーム内において直接または間接的に他のプレイヤーと共謀を図ること。
          <br><span class="en">e.</span>
          当サイトのイベントまたはプロモーションを濫用することを厳格に禁じます。
          <br><span class="en">f.</span>
          万が一当サイトで他のプレイヤーとの共謀行為が確認された場合、当サイトは適切な措置を講じる権利を留保し、お客様と他のプレイヤーの損失については責任を負いません。
          <br><span class="en">g.</span>
          万が一お客様が他のプレイヤーによる共謀行為、詐欺などの犯罪行為を確認された場合、当サイトまでご連絡ください。
          <br><span class="en">h.</span>
          お客様が当サイトのサービスやソフトウェアを悪用していることが判明した場合、勝winはお客様のアカウントをブロックし、アカウント内の資金を没収する権利を有します。
          <br><span class="en">i.</span>
          出金条件を満たすためにゲームモードに手を加え、ゲーム構造を悪用しようとしている、または悪意を持って使用されていることが判明した場合、当社はすべてのボーナスと利益を没収するか、お客様のアカウントを直接閉鎖する権利を有します。
        </div>
        <br><br>
        <span class="num">36.</span>
        お客様が当サイトで提供されるサービスが娯楽目的のみであることに同意したものとみなします。サービスの利用を強制ではなく、お客様ご自身の判断でサービスを利用するかどうかを選択‧決定することができます。
        したがって、当サイトにアクセスするお客様は、自己の責任においてゲームをプレイする必要がございます。お客様は当サイトにアクセスし、ご自身の名前で娯楽目的で当サイトが提供するサービスを楽しむことに同意したものとみなします。当サイトは、お客様が他の方法で当サイトが提供するサービスを利用することを固く禁じます。
        <br><br>
        <span class="num">37.</span>
        勝winは、お客様に事前に通知することなく、独自の裁量により当サイトおよび/または一部のゲームまたはマーケット製品を一時停止、変更、削除、および/または追加する権利、また一時的にまたは永久的に利用停止措置を取る権利を留保し、その結果としてお客様が被ったいかなる損失についても責任を負いません。
        <br><br>
        <span class="num">38.</span>
        いかなる理由においても、承認されたゲームラウンドが何らかの理由で中断または終了した場合、すべてのお客様の取引は正確に記録され、ゲームの再開時に未完了のゲームラウンドは途中から再開されます。
        回復が不可能だった場合、勝winはゲームラウンドを削除し、お客様のアカウントに賭け金を返金いたします。
        <br><br>
        <span class="num">39.</span>
        勝winが制御不能状態に陥った場合、例：予期しない技術的な問題または第三者事業者による技術的な問題が発生した場合、勝winは賭けをキャンセルまたは返金する場合がございます。またお客様は、コンピューターまたはモバイルデバイスのパフォーマンスとネットワーク接続が当サイトのパフォーマンスと操作に影響を与える可能性があることに同意する必要があり、勝winはお客様の機器、ネットワーク接続、またはサードパーティのプロバイダーによって引き起こされる誤動作や問題についての責任を負いません。
        これらにはゲームをプレイすることができない、または特定のゲームに関連する情報を表示または受信できないことを含みます。
        <br><br>
        <span class="num">40.</span>
        勝winは当サイトが完璧にまたはエラーなく機能し、お客様が当サイトおよび当サイトが提供するゲームに中断なくアクセスでき、当サイトとゲームが目的に一致している場合、それらが明示的か黙示的かのいかんに関わらず保証は行わないものとします。
        <br><br>
        <span class="num">41.</span>
        当サイトのすべての知的財産権(IP権)は、勝winまたはサードパーティのソフトウェア事業者に帰属します。
        当サイトの利用は、お客様がサイトまたはソフトウェアプロバイダーの知的財産権を所有していることを意味するものではありません。
        知的財産権には、特許、著作権、意匠権、商標、データベース権および上記の権利の応用が含まれます。また、著作者の人格権、専有技術、企業秘密、機密情報、ドメイン名、URL商号およびその他すべての知的財産権
        (およびそれに関連するライセンス)が含まれています。
        これらには登録されているかどうか、登録可能かどうか、特定の国や地域、または世界の他の場所に居住しているかどうかが含まれますが、これらに限定されません。
        <br><br>
        <span class="num">42.</span>
        お客様は適用される法律の範囲で、次のことを行ってはなりません:
        <div class="en-box">
          <br><span class="en">a.</span>
          ソフトウェアおよび/または当サイトのコピー、配布、公開、リバースエンジニアリング、逆コンパイル、逆アセンブル、変更、変換、翻訳、またはその他の方法でデコードすること、またはソフトウェアおよび/またはサイトのソースコードから二次的著作物を作成するためにソースコードを取得しようとすること。
          <br><span class="en">b.</span>
          ソフトウェアおよび/または当サイト、またはその一部から著作権、所有権、または同様の通知を削除すること。
          <br><span class="en">c.</span>
          ソフトウェアの販売、譲渡、サブライセンス、譲渡、頒布またはリースすること。
          <br><span class="en">d.</span>
          コンピュータネットワークまたはその他の手段を介してソフトウェアを第三者に提供すること。
          <br><span class="en">e.</span>
          ソフトウェアを物理的または電子的な方法で任意の国に輸出すること。
          <br><span class="en">f.</span>
          適用される法律または規制で禁止されている方法でソフトウェアを使用すること。
          <br><span class="en">g.</span>
          知的財産権に損害を与える、または損害を与える可能性のある行為、またはInitial
          Singularity
          Limited社、その従業員、取締役、役員、コンサルタントのイメージや評判を傷つける行為。
          <span class="en">h.</span>
          本規約で明示的に許可されていない方法で、ソフトウェアおよび/または当サイト、またはその一部を使用する。
        </div>
        <br><br>
        <span class="num">43.</span>
        お客様は、当サイトまたはゲーム内でプレイヤーが使用する名前や画像(プレイヤーのアカウントなど)が第三者の知的財産権、プライバシー、その他の権利を侵害しないこと、また他人に不快感を与えないこと
        。 当サイトのプライバシー
        ポリシーの条項に従って、当サイトまたはゲームに関連するあらゆる目的で使用するために、お客様はそれらの名前や画像の、取消不能、譲渡可能、ロイヤルティフリー、およびサブライセンスの許可の権利を勝winに付与します。
        <br><br>
        <span class="num">44.</span>
        お客様が当サイトのサービスに関してご意見などございましたら、当サイトの指示に従ってカスタマーサービスチームに連絡いただくか、support@katsuwin.ai
        宛にメールをご送付ください。
        特定のゲームに関するご意見、お問い合わせは、問題が発生してから 7
        営業日以内に行う必要がございます。
        支払い、アカウントの停止、ボーナスの計算に関してはこれらに限定されないものといたします。
        その他の事項に関しては、問題が発生してから 1
        か月以内にご連絡いただく必要がございます。
        ご意見、お問い合わせに関してはカスタマーサービスチームがご対応いたします。カスタマーサービススタッフが問題をすぐに解決できない場合は、勝winの内部担当者が対応し、お客様には現在のお問い合わせ状況を適切にお知らせいたします。
        当サイトでは、通常14営業日以内に問題を解決するために最善を尽くします。
        <br><br>
        <span class="num">45.</span>
        お客様はカスタマーサービスに連絡し、いつでもアカウントを閉鎖し、利用可能な残高を引き出すことができます。
        お客様のアカウントの残高がマイナスの場合は、ただちに当サイトにお支払い手続きをしていただく必要がございます。お客様のアカウントは、全額返金された場合にのみ閉鎖できます。アカウント閉鎖時にアカウントに未決済の賭け金がある場合、それらは有効とみなされ
        (当サイトの利用規約に従ってキャンセル/無効化される場合を除く)、お客様は当サイトにご連絡いただきますと、結果として得られた賞金を回収することができます。
        (当サイトが利用規約に従い賞金の全部または一部を留保する権利を留保しないことに限定いたします)
        <br><br>
        <span class="num">46.</span>
        当サイトは以下の事案が発生した場合、説明なしにお客様のアカウントを一時停止または終了し、お客様が行った賭けを取り消し、アカウントから賞金を削除し、および/または当サイトが適切とみなすその他の措置を講じる権利を留保します。
        お客様とのビジネス関係を維持し続けることが、当サイトのライセンスおよび一般的な規制上の義務、または当サイトのサービスに悪影響を与える可能性があると当サイトが判断した場合。
        お客様が当サイトにおいて違法または詐欺行為に値する行為をされた場合。
        お客様がギャンブル禁止地域に在住、または禁止地域で当サイトのゲームをご利用いただいた場合。
        お客様がいかなる利用規約に違反された場合。
        法律または当サイトの第三者ライセンス許諾者により、当サイトに措置を講じるよう命じられた場合。
        <div class="en-box">
          <br><span class="en">a.</span>
          本規約の第12条に記載されている理由により、当サイトがお客様のアカウントを終了した場合、お客様がこれらの規約および利用規則を遵守していれば、当サイトはお客様がその時点で保有している議論の余地のないアカウント残高を返金します。
          法律で認められる最大限の範囲で、当サイトはお客様に対して一切の責任を負いません。
          上述の内容は適切な状況において、お客様に対して法的措置を講じる当ウェブサイトの権利を排除するものではございません
        </div>
        <br><br>
        <span class="num">47.</span>
        如何なる場所において、勝winに関わる全ての者へ対して攻撃的、誹謗中傷、侮辱するような発言、その他不快な内容の発言や行動をされた場合は、当サイトの権限によりお客様のアカウントを停止または制限する可能性がございます。また、引き続きチャットやメールのお返事を中止することがございます。
        <div class="center2">
          <span class="tittle">責任あるギャンブル</span>
        </div>
        <span class="num">1.</span>
        ほとんどのお客様にとってギャンブルは娯楽、楽しみ、刺激を意味しますが、一部のお客様にとってはギャンブルがマイナスの影響を与えることも認識されております。
        医学的観点から見ると、ギャンブル依存症は以前から深刻な問題であると捉えられております。
        当サイトでは運営当初からこのことを考慮し、全力でサポートしていく所存でございます。
        「責任あるギャンブル」では、ギャンブル提供者が多段階の対策を通じてマイナスの影響を引き起こす可能性を軽減できることを理解しており、マイナスの影響が生じた場合には、積極的にそれに対抗する措置を講じるよう努めます。
        ギャンブルへのマイナスの影響に対抗するための最も重要なことは、ギャンブルのリスクについての理解と教育、そしてお客様がマイナスの影響に陥らないように自制するようサポートすることです。
        <br><br>
        <span class="num">2.</span>
        ギャンブルを楽しみ、マイナスの影響が生じることを避けるために、ギャンブルをする前に次のことを考慮することをお勧めいたします。
        入金限度額を設定する
        ギャンブルを始める前に、自分の経済状況に基づいてギャンブルにどれだけの金額を賭けることができるかを検討してください。
        ギャンブルはお客様の娯楽の為にございます。
        一切を惜しまず損失を取り戻そうとしないこと。
        大きなリスクを冒さず、どんな犠牲を払ってでも以前の損失を取り戻そうとしないでください。
        ギャンブルは楽しむためのものであり、お金を稼ぐためのものではありません。
        制限時間を設定する 制限時間を設定し、それを守るようにしてください。
        ギャンブルだけがあなたの趣味ではありません。ギャンブルと他の趣味のバランスを見つけることを心がけてください。
        賢く遊ぶ
        極度に緊張しているとき、落ち込んでいるとき、または極度のストレスにさらされているときは、ギャンブルをしないことを選択するのが賢明です。
        休息
        疲労が溜まっている時または集中力が低下している際は、休息を取るようにしてください。
        アカウントは1つのみ作成
        ギャンブルにどれだけの時間とお金を費やしているかを把握するために、複数のアカウントを作成することを禁止いたします。
      </div>
    </section>

    <footer-vue />
    <go-to-top />
  </div>
</template>

<script>
import footerVue from '@/components/footer'
import goToTop from '@/components/goToTop'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'LandingPage',
  components: {
    footerVue,
    goToTop,
    VueSlickCarousel
  },
  data() {
    return {
      // for event
      slick_setting: {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2.5
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      },
      // for slide1
      slick_setting_2: {
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 15000,
        cssEase: 'linear',
        arrows: false,
        swipe: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        centerMode: true,
        initialSlide: 3,
        variableWidth: true
      },
      // for slide2
      slick_setting_3: {
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7500,
        cssEase: 'linear',
        arrows: false,
        swipe: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        centerMode: true,
        initialSlide: 3,
        variableWidth: true
      },
      slide1: [
        {
          image: 'BarbarianFury.png',
          text: 'Barbarian Fury.png'
        },
        {
          image: 'HawaiianDreamXmas.png',
          text: 'Hawaiian Dream Xmas'
        },
        {
          image: 'PyramidRisingx33.png',
          text: 'Pyramid Rising x33'
        },
        {
          image: 'RichWildeandtheTomeofInsanity.png',
          text: 'Rich Wilde and the Tome of Insanity'
        },
        {
          image: 'TheGoldenOwlofAthena.png',
          text: 'The Golden Owl of Athena'
        },
        {
          image: 'TheSwordandtheGrailExcalibur.png',
          text: 'The Sword and the Grail Excalibur'
        }
      ],
      slide2: [
        {
          image: 'BattleDwarfXmas.png',
          text: 'Battle Dwarf Xmas'
        },
        {
          image: 'BoatBonanzaDownUnder.png',
          text: 'Boat Bonanza Down Under'
        },
        {
          image: 'OiranDreamXmas.png',
          text: 'Oiran Dream Xmas'
        },
        {
          image: 'SparkofGenius.png',
          text: 'Spark of Genius'
        },
        {
          image: 'Starstruck.png',
          text: 'Starstruck'
        },
        {
          image: 'DragonKingHotPots.png',
          text: 'Dragon King Hot Pots'
        }
      ],
      bonusAmount: '2000'
    }
  },
  computed: {
    brandImage() {
      const brandImage = this.$store.state.brand.brandImage.img_event
      return Array.isArray(brandImage)
        ? [...brandImage].sort((a, b) => a.sort - b.sort)
        : []
    },
    gameCategory() {
      const category = Array.isArray(this.$store.getters.gameCategory)
        ? this.$store.getters.gameCategory.slice()
        : []

      return [...category].sort((a, b) => a.sorting - b.sorting)
    }
  },
  created() {
    // Extract the bonus amount from the route path
    const pathMatch = this.$route.path.match(/landingPage(\d+)/)
    if (pathMatch && pathMatch[1]) {
      this.bonusAmount = pathMatch[1]
    }
  },
  methods: {
    redirectToHome(type) {
      // 取得當前 URL 的查詢參數
      const urlParams = new URLSearchParams(window.location.search)
      const shareCode = urlParams.get('share_code')

      // 建立新的目標 URL
      let targetUrl = '/'
      if (shareCode) {
        targetUrl += `?share_code=${shareCode}`
      } else if (type === 'register') {
        localStorage.setItem('fromLandingPageRegister', true)
      }

      this.$router.push(targetUrl)
    },
    handleClick(banner_url, open_type) {
      const id = banner_url.match(/eventId=(\d+)/)[1] || banner_url.split('/').pop()

      switch (open_type) {
        case 'self':
          this.$router.push({ path: '/event', query: { eventId: id }})
          break

        case 'iframe':
          this.$store.commit('SET_GAME_URL', banner_url)
          break

        case 'new':
          window.open(banner_url, '_blank')
          break

        default:
          this.$router.push({ path: '/event', query: { eventId: id }})
      }
    },
    changeGameCategory(item) {
      item.attribute = 'category'
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', item)
      localStorage.setItem('fromLandingPage', true)
      this.$router.push('/')
    }
  }
}
</script>

